import { mainApi } from '../../../api/mainApi';
import { AccessState } from '../../../types';
import { middlewareApi } from '../../middleware/middlewareApi';
import { ErrorLogPayload } from '../interfaces/errorLog.interface';

export const errorLogTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['PersonDebtor'],
});
// Define a service using a base URL and expected endpoints
export const errorLogApi = errorLogTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @POST create collaborator
     */
    reportError: builder.mutation<any, { logPayload: Partial<ErrorLogPayload> }>({
      queryFn: async ({ logPayload }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.post<any>('/error-log-legacy', {
            user_profile_id,
            ...logPayload,
            is_frontend: '1',
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'PersonDebtor', id: 'LIST' }],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useReportErrorMutation } = errorLogApi;
